import React from "react";
import UserPage from "../../common/UserPage/UserPage";
import Footer from "../../common/Footer/Footer";
import UserSupportPage from "../../components/UserSupportPage.jsx/UserSupporPage";
import { useSelector } from "react-redux";

function MyWalletPage() {
    const { currentUser } = useSelector((state) => state.users);
  return (
    <div>
      <UserPage customImage={currentUser?.picture} />
      <UserSupportPage />
      <Footer />
    </div>
  );
}

export default MyWalletPage;